module.exports = __webpack_public_path__ + "img/e486e2ff9e5587096ee013b99518c2b5.png";